var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"text-primary cursor-pointer rotate-45",attrs:{"size":"21","icon":_vm.currentContentWidth.icon},on:{"click":_vm.toggleContentWidth}})}
var staticRenderFns = []

export { render, staticRenderFns }